/* istanbul ignore file */
import { roundAverageProductRating } from 'src/utils/roundAverageProductRating';

export { LOADING_REVIEWS } from '../../CustomersReviewsPreview/constants/copy';

export const BACK = 'Back';
export const CLOSE = 'Close';
export const DRAWER_CONTENT_LABEL = 'Customer reviews';
export const REVIEW_DRAWER_CONTENT_LABEL = 'Customer review';
export const ERROR_REVIEWS = 'Reviews are unavailable right now. Please try again shortly.';
/** Opens the rating listbox, which is labelled FILTER_LABEL. */
export const FILTER_BUTTON = 'Filter';
export const FILTER_LABEL = 'Filter by rating';
export const FILTER_ALL = 'Show all';
export const NEXT_PAGE = 'Next page';
export const PAGINATION_LABEL = 'Review pages';
export const NO_REVIEWS = 'No reviews for this product yet.';
export const PHOTOS_HEADING = 'Photos from reviews';
export const PREVIOUS_PAGE = 'Previous page';
export const RATING_HELP_HREF = '/rating_help.html';
export const VERIFIED_REVIEWS = 'Verified product reviews';

export const reviewCountHeading = (count: number) =>
  count === 1 ? '1 review' : `${count} reviews`;

/** Shown in place of the list when a filter matches nothing. */
export const noReviewsForRating = (rating: number) =>
  `No ${rating}-star reviews for this product yet.`;

export const ratingFilterLabel = (rating: number) => `${rating} ${rating === 1 ? 'star' : 'stars'}`;

/** Drawn beside the star. */
export const averageRatingDisplay = (average: number) => `${roundAverageProductRating(average)}/5`;

/** Read aloud in place of the slash. */
export const averageRatingLabel = (average: number) =>
  `${roundAverageProductRating(average)} out of 5`;
